import React from 'react';
import ProgressiveBackground from '@ifit/mp-progressive-background';
import cx from 'classnames';
import useToggle from '@ifit/hooks/useToggle';
import useDimensions from 'react-use-dimensions';
import { useHistory } from 'react-router-dom';
import { getTrainerName, getClassName, isMobile } from '../../../../helpers';
import { default as ReadMore } from '../read-more';
import { default as CloseButton } from '../close-button';
import {
  readMoreButtonText,
  closeBioText,
  readBioText,
} from '../../../../i18n/translations';
import { withTheme } from '@ifit/themes/withTheme';
import './index.scss';
import { useDeviceType } from '../../../../store/device-type';

const className = getClassName('trainer-spotlight');

const Spotlight = props => {
  // TODO: typed trainer as ITrainerGetResponseOK
  const { trainer, loading } = props;
  const deviceType = useDeviceType();

  const { action } = useHistory();

  const mobile = isMobile(deviceType);
  const [bioIsOpen, toggleBio] = useToggle();
  const [containerRef, { height: openHeight }] = useDimensions({
    liveMeasure: false,
  });
  const [titleBarRef, { height: initialHeight }] = useDimensions({
    liveMeasure: false,
  });

  return (
    <div className={className()} ref={containerRef}>
      {(loading || trainer?.profileImageUrl) && (
        <ProgressiveBackground
          forceLoading={loading}
          resizeOptions={{ useStandardDimensions: false }}
          image={trainer?.profileImageUrl}
        />
      )}
      {!loading && trainer?.id && (
        <div
          data-testid="title-bar"
          className={cx(className('title-bar'), {
            [className('title-bar', 'animated')]: action !== 'POP',
          })}
          ref={titleBarRef}
          style={{ height: bioIsOpen ? openHeight : initialHeight }}
        >
          {mobile && (
            <div
              className={cx(className('close'), {
                [className('close', 'open')]: bioIsOpen,
              })}
            >
              {
                // eslint-disable-next-line react/jsx-no-bind
                <CloseButton onClick={() => toggleBio(false)} />
              }
            </div>
          )}
          <div className={className('name')}>
            <h1 data-testid="trainer-name">{getTrainerName(trainer)}</h1>
            {!mobile && <h2>{trainer.title}</h2>}
          </div>
          <div className={className('bio')}>
            <div className={className('quote')}>{trainer.shortBio}</div>
            {trainer.longBio && (
              <ReadMore
                className={className('bio-text')}
                lines={mobile ? 4 : 0}
                animate
                open={bioIsOpen}
                toggle={toggleBio}
                toggleContent={{
                  minimize: false,
                  expand: mobile ? (
                    <button className={className('read-more-btn')}>
                      {readMoreButtonText()}
                    </button>
                  ) : (
                    false
                  ),
                }}
              >
                {trainer.longBio}
              </ReadMore>
            )}
            {!mobile && (
              <div>
                <button
                  type="button"
                  className={className('toggle-btn')}
                  onClick={toggleBio}
                >
                  {bioIsOpen ? closeBioText() : readBioText()}
                </button>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default withTheme(Spotlight);
